module.exports = __webpack_public_path__ + "img/star-logo.acced15c.jpg";